import React, { useEffect, useRef } from 'react'
import { downloadInFrameIfSupported } from '@disco/utils/target-iframe'
type Props = {
  url: string | null | undefined
}

/**
 * Download link component that automatically triggers file downloads
 * Handles iframe-supported downloads and auto-clicks on mount
 * @param url - URL of the file to download
 */
const DownloadLink = ({ url }: Props): React.ReactElement<'a'> => {
  const ref = useRef<HTMLAnchorElement>(null)
  useEffect(() => {
    if (url && ref.current) {
      ref.current.click()
    }
  }, [])
  return (
    <a
      download
      href={url ?? undefined}
      ref={ref}
      target={downloadInFrameIfSupported() ?? undefined}
    />
  )
}

export default DownloadLink
